import { useCallback } from "react";
import Particles from "react-particles";
import { loadSlim } from "tsparticles-slim"; // if you are going to use `loadSlim`, install the "tsparticles-slim" package too.

export const ParticleImageComponent = () => {
  const particlesInit = useCallback(async (engine) => {
    console.log(engine);
    await loadSlim(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
    await console.log(container);
  }, []);

  return (
    <div className="relative w-full overflow-hidden" style={{zIndex:2}}>
      <Particles
     
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        width="100%"
        height="300px"
        options={{
          fpsLimit: 120,
          interactivity: {
            events: {
              onClick: {
                enable: true,
                mode: "push",
              },
  
              resize: true,
            },
            modes: {
              push: {
                quantity: 0,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
            },
          },
          particles: {
            color: {
              value: "#ccc",
            },
            line_linked: { enable: false },

            move: {
              direction: "none",
              enable: true,
              out_mode: "out",
              outModes: "out",
              speed: 1,
            },
            number: {
              density: {
                enable: true,
              },
              value: 10,
            },
            opacity: {
              value: 0.3,
            },
            shape: {
              type: ["image"],
              image: [
                {
                  src: "/pointzap-logo.png",
                  height: 20,
                  width: 20,
                },
                {
                  src: "/tron3d-logo.png",
                  height: 20,
                  width: 20,
                },
                {
                  src: "/usdt-logo.png",
                  height: 20,
                  width: 20,
                },
              ],
            },
            size: {
              value: 20,
              random: false,
              anim: {
                enable: true,
                speed: 4,
                size_min: 10,
                sync: false,
              },
            },
          },
          detectRetina: true,
        }}
      />
    </div>
  );
};
